import React from "react";
import PsModalWindow from "../../components/PsModalWindow";
import UserLogins from "../settings/userLogins";

const AgencyUserLoginsComponent = (props) => {
  const field = (fieldName) => props.dataSource[fieldName] || "";

  return (
    <>
      <UserLogins agencyId={props.dataSource.id} />
    </>
  );
};
const AgencyUserLogins = (props) => {
  return (
    <>
      <PsModalWindow size="xl" title="Agency User Logins" {...props}>
        {props.show && <AgencyUserLoginsComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default AgencyUserLogins;
